import React from "react";
import Perfil from "../../pages/usuario/Perfil";
import Usuarios from "../../pages/usuario/Usuarios";

const prefix = process.env.REACT_APP_PREFIX;

const usuarioRoutes = [
  {
    path: `${prefix}/Perfil`,
    component: <Perfil />,
    title: "perfil do usuário",
  },
  {
    path: `${prefix}/usuarios`,
    component: <Usuarios />,
    title: "gerenciar usuários",
  },
];

export default usuarioRoutes;
